import { render, staticRenderFns } from "./crmBranchs.vue?vue&type=template&id=0eb918a5&scoped=true"
import script from "./crmBranchs.vue?vue&type=script&lang=js"
export * from "./crmBranchs.vue?vue&type=script&lang=js"
import style0 from "./crmBranchs.vue?vue&type=style&index=0&id=0eb918a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb918a5",
  null
  
)

export default component.exports